import React from 'react'
import {style} from '../../util/style'
import {CtaPreview, CtaPreviewType} from '../layout/cta/CtaPreview'
import {Block} from './Blocks'

const styles = style('ctapreviewblock')

export type CtaPreviewBlockType = CtaPreviewType & {
	container?: boolean
	sidebar?: boolean
}

export const CtaPreviewBlock: React.FC<CtaPreviewBlockType> = ({
	container,
	sidebar,
	...block
}) => {
	const image = block.image || block.preview_image || block.hero_image
	const title = block.preview_title || block.hero_title || block.title
	const text = block.text || block.preview_text || block.hero_text
	if (!image && !title && !text) return null

	return (
		<Block className={styles()} container={container} sidebar={sidebar}>
			<CtaPreview {...block} />
		</Block>
	)
}
